export default [

    // 10/10

    {
        id: 1,
        day: '10/10 THUR',
        routes: [{
            time: '10:35-10:50',
            cover: 'sche_1.png',
            title: '静音乐队（古典）',
            artist: '弦乐：胡芮熙；钢琴：杨洋',
            id: 1
        },

        {
            time: '11:30-11:45',
            cover: 'sche_2.png',
            title: '静音乐队（管乐）',
            artist: '上海音乐学院铜管五重奏',
            id: 2
        },
        {
            time: '12:00-12:15',
            cover: 'sche_6.png',
            title: '双排键独奏',
            artist: '中野正英',
            id: 3
        },

        {
            time: '12:40-12:55',
            cover: 'sche_4.png',
            title: '人工智能伴奏演示',
            artist: '吴晓 青年钢琴演奏家',
            id: 4
        },
        {
            time: '13:30-13:45',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 5
        },
        {
            time: '13:30-13:45',
            cover: 'sche_3.png',
            title: '静音乐队（摇滚）',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 6
        },
        {
            time: '14:30-14:45',
            cover: 'sche_7.png'
            , title: '电子键盘演示',
            artist: '岛田由羽希',
            id: 7
        },
        {
            time: '15:20-15:35',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 8
        },
        {
            time: '16:00-16:15',
            cover: 'sche_4.png',
            title: '人工智能伴奏演示',
            artist: '吴晓 青年钢琴演奏家',
            id: 9
        }]
    },
    // 10/11
    {
        id: 2,
        day: '10/11 FRI',
        routes: [{
            time: '10:35-10:50',
            cover: 'sche_1.png',
            title: '静音乐队（古典）',
            artist: '弦乐：胡芮熙；钢琴：杨洋',
            id: 10
        },
        {
            time: '11:30-11:45',
            cover: 'sche_2.png',
            title: '静音乐队（管乐）',
            artist: '上海音乐学院铜管五重奏',
            id: 11
        },
        {
            time: '12:00-12:15',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 12
        },
        {
            time: '12:40-12:55',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 13
        },
        {
            time: '13:30-13:45',
            cover: 'sche_6.png',
            title: '双排键独奏',
            artist: '中野正英',
            id: 14
        },
        {
            time: '14:00-14:15',
            cover: 'sche_3.png',
            title: '静音乐队（摇滚）',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 15
        },
        {
            time: '14:30-14:45',
            cover: 'sche_4.png',
            title: '人工智能伴奏演示',
            artist: '吴晓 青年钢琴演奏家',
            id: 16
        },
        {
            time: '15:20-15:35',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 17
        },
        {
            time: '16:00-16:15',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 18
        }]
    },
    // 10/12
    {
        id: 3,
        day: '10/12 SAT',
        routes: [{
            time: '10:10-10:25',
            cover: 'sche_7.png',
            title: '电钢琴演示',
            artist: '岛田由羽希',
            id: 19
        },
        {
            time: '10:35-10:50',
            cover: 'sche_1.png',
            title: '静音乐队（古典）',
            artist: '弦乐：胡芮熙；钢琴：杨洋',
            id: 20
        },
        {
            time: '11:00-11:15',
            cover: 'sche_4.png',
            title: '人工智能伴奏演示',
            artist: '吴晓 青年钢琴演奏家',
            id: 21
        },
        {
            time: '11:30-11:45',
            cover: 'sche_2.png',
            title: '静音乐队（管乐）',
            artist: '上海音乐学院铜管五重奏',
            id: 22
        },
        {
            time: '12:00-12:15',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 23
        },
        {
            time: '12:40-12:55',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 24
        },
        {
            time: '13:30-13:45',
            cover: 'sche_7.png',
            title: '电子键盘演示',
            artist: '岛田由羽希',
            id: 25
        },
        {
            time: '14:00-14:15',
            cover: 'sche_1.png',
            title: '静音乐队（古典）',
            artist: '弦乐：胡芮熙；钢琴：杨洋',
            id: 26
        },
        {
            time: '14:30-14:45',
            cover: 'sche_4.png',
            title: '人工智能伴奏演示',
            artist: '吴晓 青年钢琴演奏家',
            id: 27
        },
        {
            time: '15:20-15:35',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 28
        },
        {
            time: '16:00-16:15',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 29
        }]
    },
    // 10/13
    {
        id: 4,
        day: '10/13 SUN',
        routes: [{
            time: '10:10-10:25',
            cover: 'sche_3.png',
            title: 'ASTERISM乐队 演出',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 30
        },
        {
            time: '10:35-10:50',
            cover: 'sche_3.png',
            title: '静音乐队（摇滚）',
            artist: 'ASTERISM乐队<br/>吉他手HAL-CA、贝斯手 MIYU、鼓手 MIO',
            id: 31
        },
        {
            time: '11:00-11:15',
            cover: 'sche_5.png',
            title: '无人乐队 自动演奏技术体验',
            artist: '雅马哈Real Sound  Viewing自动演奏技术',
            id: 32
        },

        {
            time: '11:30-11:45',
            cover: 'sche_2.png',
            title: '静音乐队（管乐）',
            artist: '上海音乐学院铜管五重奏',
            id: 33
        },
        {
            time: '12:00-12:15',
            cover: 'sche_7.png',
            title: '电钢琴演示',
            artist: '岛田由羽希',
            id: 34
        }
    ]
    }
]